import { useCallback, useMemo } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { ContentSegmentDocumentMetadata } from '@candu-ai/content/types';
import { tabs, VIEW_QUERY_PARAM } from 'dashboard/pages/Content/pages/Analytics/analyticsTabs';

import { AnalyticsState } from './reducer';

export const selectAnalytics = ({ analytics }: RootStateOrAny): AnalyticsState => analytics;
export const useAnalyticsState: () => AnalyticsState = () => useSelector(selectAnalytics);

const queryParamsLookup = Object.fromEntries(tabs.map((r) => [r.queryParam, r.key]));

export const useAnalyticsActiveView = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeViewQueryParam = searchParams.get(VIEW_QUERY_PARAM);

  const activeView = useMemo(
    () => queryParamsLookup[activeViewQueryParam || tabs[0]?.queryParam || ''],
    [activeViewQueryParam, queryParamsLookup, searchParams],
  );

  const setActiveView = useCallback((queryParam) => {
    searchParams.set(VIEW_QUERY_PARAM, queryParam);
    setSearchParams(searchParams);
  }, []);

  return { activeView, setActiveView };
};

export const useContentSegments = (): ContentSegmentDocumentMetadata[] =>
  useSelector(selectAnalytics)?.contentSegments || [];
